export default {
  namespaced: true,
  state: {
    news: [],
    unreadNewsCount: 0,
    publication: null,
    instructions: [],
    instruction: null,
  },
  actions: {
    GetNews({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'news', value: [] });
      return new Promise((resolve, reject) => {
        const data = { profile_id: payload.profile_id };
        if (payload.limit) {
          data.limit = payload.limit;
        }
        rootGetters.axl.post('news/api/news', data)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'news', value: response.data.news });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetUnreadNewsCount({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'news', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('news/api/news', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              const unreadNew = response.data.news.filter(n => !n.readed);
              commit('setField', { name: 'unreadNewsCount', value: unreadNew.length });
              resolve(unreadNew.length);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    SetPublication({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'publication', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('news/api/news', { profile_id: payload.profile_id })
          .then((response) => {
            if (response && response.data) {
              const item = response.data.news.find(n => n.id === payload.publication_id);
              if (item) {
                commit('setField', { name: 'publication', value: item });
                resolve(response.data);
              } else {
                reject(new Error('no response data'));
              }
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    SetPublicationReaded({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('news/api/news/readed', {
          profile_id: payload.profile_id,
          news_id: payload.news_id,
        })
          .then((response) => {
            dispatch('GetUnreadNewsCount', payload.profile_id);
            resolve(response);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetInstructions({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'instructions', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('information/api/information/list', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'instructions', value: response.data.courses });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetInstruction({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'instruction', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('information/api/information/view', { course_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'instruction', value: response.data.course });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreNews({ commit }) {
      commit('setField', { name: 'news', value: [] });
      commit('setField', { name: 'unreadNewsCount', value: 0 });
      commit('setField', { name: 'publication', value: null });
      commit('setField', { name: 'instructions', value: [] });
      commit('setField', { name: 'instruction', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
